export default function toReactCallbackName(value: string) {
  if (!value.match(/^on[A-Z]/)) {
    return `on${value[0].toUpperCase()}${value.slice(1)}`;
  }

  return value;
}
